/* Mapping props to a function instead of the actual state helps ensure the data stays up to date. */

function refreshList(state) {
	if(state.list){
		return state.list
	}
	return []
}

function refreshPinned(state) {
	if(state.pinned){
		return state.pinned
	}
	return []
}

function isLoading(state) {
	// if(state.loading){
		return state.loading
	// }
}

function refreshPostWithId(state, id){
	if(state.details){
		return state.details[id]
	}
	return null
}


function refreshSchedule(state){
	if(state.schedule){
		return state.schedule
	}
}

function refreshScheduleWithId(state, id){
	if(state.schedule){
		if(state.schedule.filter(item => item.id === id).length > 0){
			return state.schedule.filter(item => item.id === id)[0]
		}

	}
	return null
}


export default {
	isLoading,
	refreshList,
	refreshPinned,
	refreshPostWithId,
	refreshSchedule,
	refreshScheduleWithId
};
